export enum UserRol {
	admin = 'ADMIN',
	client = 'CLIENT',
	editnot = 'EDITNOT',
	admcli = 'ADMCLI'
}

export interface TokenDecoded {
	access_token: string;
	refresh_token: string;
	token_type: string;
	expires_in: number;
	refresh_expires_in: number;
	'.issued': string;
	'.expires': string;
	userName: string;
	idTipo: number;
	userRol: UserRol;
	nombre: string;
	apePaterno: string;
	apeMaterno: string;
	email: string;
	userId: number;
	clientId?: number;
}

export class TokenModel {
	access_token: string;
	refresh_token: string;
	token_type: string;
	expires: string;
	issued: string;
	expires_in: number;
	refresh_expires_in: number;

	constructor(tokenDecoded: TokenDecoded) {
		this.access_token = tokenDecoded.access_token;
		this.refresh_token = tokenDecoded.refresh_token;
		this.token_type = tokenDecoded.token_type;
		this.expires = tokenDecoded['.expires'];
		this.issued = tokenDecoded['.issued'];
		this.expires_in = tokenDecoded.expires_in;
		this.refresh_expires_in = tokenDecoded.refresh_expires_in;
	}
	get expirationDate(): Date {
		return new Date(this.expires);
	}

	get isExpired(): boolean {
		if (!this.expires)
			return true;
		return this.expirationDate <= new Date();
	}

	get refreshExpirationDate(): Date {
		if (!this.issued)
			return new Date(0);

		const issuedDate = new Date(this.issued);
		return new Date(
			issuedDate.getTime() + this.refresh_expires_in * 1000
		);
	}

	get isRefreshExpired(): boolean {
		return this.refreshExpirationDate <= new Date();
	}
}

export class UserModel {
	token: TokenModel;
	userName: string;
	userRol: UserRol;
	idTipo: number;
	nombre: string;
	apePaterno: string;
	apeMaterno: string;
	fullName: string;
	email: string;
	userId: number;
	clientId?: number;

	constructor(tokenDecoded?: TokenDecoded) {
		if (tokenDecoded) {
			this.token = new TokenModel(tokenDecoded);
			this.userName = tokenDecoded.userName || '';
			this.userRol = (tokenDecoded.userRol as UserRol) || null;
			this.userId = this.toNumber(tokenDecoded.userId);
			this.nombre = tokenDecoded.nombre || null;
			this.apePaterno = tokenDecoded.apePaterno || null;
			this.apeMaterno = tokenDecoded.apeMaterno || null;
			this.fullName = `${this.nombre} ${this.apePaterno} ${this.apeMaterno}`.trim();
			this.email = tokenDecoded.email;
			this.clientId = this.toNumber(tokenDecoded.clientId);
			this.idTipo = this.toNumber(tokenDecoded.idTipo);
		}
	}

	private toNumber(value: any): number | null {
		return value !== undefined && value !== null ? Number(value) : null;
	}

	isAdmin() {
		return this.userRol === UserRol.admin;
	}

	isClient() {
		return this.userRol === UserRol.client;
	}

	hasRole(rols: UserRol[]) {
		return rols.includes(this.userRol);
	}

	isAuthenticated(): boolean {
		return !!this.userId && !!this.token;
	}
}
